import { ListMeta } from "./common";

export interface DeepResearch {
  id: string;
  seller_company_name: string;
  prospect_company_name: string;
  prospect_id: number;
  campaign_id: number | null;
  status: number;
  notes: Record<string, any>;
  deep_research_analysis_file_key: string;
  deep_research_analysis_file_url: string;
  created_at: string;
}

export interface DeepResearchResponse {
  data: DeepResearch;
  metadata: ListMeta;
}

export enum DeepResearchStatus {
    NOTIFICATION_RECEIVED = 0,
    PROCESSING = 1,
    PROCESSED = 2,
    FAILED = 3,
    INITIALIZED = 4,
    REINDEXING = 5,
  }
